module.exports = __webpack_public_path__ + "img/p7.bb7f5bf3.png";